/**
 * Created by huzhongchun on 2018/10/22.
 */
import React from 'react';
import Util from 'util/util';

class ErrorHandler extends React.Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false };
	}

	componentDidCatch(error, info) {

		this.setState({
			hasError: true,
			message: error.message || '',
			componentStack: info.componentStack || ''
		});
		// You can also log the error to an error reporting service
		this.handleError(error, info);
	}

	handleError(error, info){
		let uid = document.getElementById('hidden-uid-value') ? document.getElementById('hidden-uid-value').value : '';
		Util.addEventGa(process.env.PROJECT_LABEL||'react','onError',uid+'_'+error.message+'_'+info.componentStack);
	}

	render() {
		if (this.state.hasError) {
			// You can render any custom fallback UI
			return <div style={{
				padding: 30
			}}>
				{
					this.state.message ? <h2>{this.state.message}</h2>:''
				}
				{
					this.state.componentStack ? <pre>{this.state.componentStack}</pre>:''
				}
			</div>;
		}
		return this.props.children;
	}
}

export default ErrorHandler;



// WEBPACK FOOTER //
// ./src/components/public/errorHandler/index.js